import type {Extra, HibuTag} from '../../../../search-types';
import type {Language} from '../../../../../i18nTypes';
import type {Option} from '../../../../../common/select/select';

export function buildDropdownTagUpdate(
    tag: HibuTag,
    selectedOption: Option,
    currentLanguage: Language,
): {
    tagId: string;
    labels: {[language: string]: string};
    extra: {[key: string]: any};
} {
    const tagId = String(selectedOption.value);
    const value_tokenized_string = tagId.substring(tagId.lastIndexOf(':') + 1);
    const label = String(selectedOption.label ?? value_tokenized_string);
    const labels = {[currentLanguage]: label};
    const extra: Extra = {
        ...tag.extra,
        value_tokenized_string,
        userValidated_bool: true,
        originalTagId_string: tag.id,
    };

    return {tagId, labels, extra};
}
